import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { PackView } from "@/components/PackView";

export default function PublicPack() {
  const { shareId } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/public/packs/${shareId}`).then((r) => setP(r.data ?? false)).catch(() => setP(false)); }, [shareId]);
  return (
    <main data-testid="public-pack-page" className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-12 space-y-6">
      <div className="flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5"><Logo className="w-9 h-9" /><span className="font-display text-2xl text-slate-900">Daybreyk</span></Link>
        <Link to="/login" data-testid="public-pack-signup" className="rounded-xl bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-brand-dark">Make your own</Link>
      </div>
      {p === null && <div className="h-40 rounded-2xl bg-surface animate-pulse" />}
      {p === false && <p data-testid="public-pack-missing" className="text-slate-500">This revision pack doesn't exist or was deleted.</p>}
      {p && (
        <>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] font-bold text-gold-300">Shared revision pack{p.author ? ` · from ${p.author}` : ""}</p>
            <h1 className="mt-2 font-display text-4xl sm:text-5xl text-slate-900 leading-tight">{p.title}</h1>
          </div>
          <PackView pack={p} />
        </>
      )}
    </main>
  );
}
